"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const HelpMenuPopover = (props) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.contactUs.root() }, "Contact us"),
    react_1.default.createElement("p", { onClick: props.onOpenOnBoardingPopup }, "View portal intro")));
exports.default = HelpMenuPopover;
